<template>
  <v-layout 
    row
    no-wrap>
    <v-flex 
      xs4
      d-flex >
      <span/>
    </v-flex>
    <v-flex  
      d-flex
      xs4>
      <v-card
        color="grey" 
        dark>
        {{ $t('page.matches.bloqued') }}
      </v-card>
    </v-flex>
    <v-flex 
      xs4
      d-flex >
      <span/>
    </v-flex>
  </v-layout>
</template>

<script>
// const debug = require('debug')('OD::BoardBlocked')

export default {
  name: 'BoardBlocked',
  components: {},
  props: {},
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  beforeDestroy() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
</style>
